var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExchangeAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#ECF3FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4496_7542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4895 29.3669H14.685C15.4376 29.3669 16.0534 29.9827 16.0534 30.7353V37.5773C16.0534 38.33 15.4376 38.9457 14.685 38.9457H14.4895C13.7369 38.9457 13.1211 38.33 13.1211 37.5773V30.7353C13.1211 29.9827 13.7369 29.3669 14.4895 29.3669ZM19.9631 25.2617C20.7157 25.2617 21.3315 25.8775 21.3315 26.6301V37.5773C21.3315 38.33 20.7157 38.9457 19.9631 38.9457C19.2105 38.9457 18.5947 38.33 18.5947 37.5773V26.6301C18.5947 25.8775 19.2105 25.2617 19.9631 25.2617ZM25.4367 33.0812C26.1893 33.0812 26.8051 33.6969 26.8051 34.4496V37.5773C26.8051 38.33 26.1893 38.9457 25.4367 38.9457C24.6841 38.9457 24.0683 38.33 24.0683 37.5773V34.4496C24.0683 33.6969 24.6841 33.0812 25.4367 33.0812Z",
    fill: "#819ACC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4496_7542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.4583,
    height: 23.4583,
    fill: "white",
    transform: "translate(8.23438 8.37402)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangeAnalysis);
export default __webpack_public_path__ + "static/media/Exchange-Analysis.17e94c60dc1e67a25e048e5b008c9979.svg";
export { ForwardRef as ReactComponent };